var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 22.5625C20.8008 22.5625 21.875 21.5371 21.875 20.2188V3.03125C21.875 1.76172 20.8008 0.6875 19.5312 0.6875H2.34375C1.02539 0.6875 0 1.76172 0 3.03125V20.2188C0 21.5371 1.02539 22.5625 2.34375 22.5625H19.5312ZM9.52148 17.7773C9.22852 18.1191 8.69141 18.1191 8.39844 17.7773L3.32031 12.6992C3.02734 12.4062 3.02734 11.918 3.32031 11.625L4.44336 10.502C4.73633 10.209 5.22461 10.209 5.51758 10.502L8.98438 13.9199L16.3086 6.5957C16.6016 6.30273 17.0898 6.30273 17.3828 6.5957L18.5059 7.71875C18.7988 8.01172 18.7988 8.5 18.5059 8.79297L9.52148 17.7773Z",
    fill: "#27509F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ffa11647c155d1988f6aaff190f5996a.svg";
export { ForwardRef as ReactComponent };